// @ts-check

import { dbGet, dbPostWithFormData } from "utils/DBFetchers";

/** @typedef {{ data: Array<{ period: number, enrolled_pharmacies: number, active_pharmacies: number, new_pharmacies_with_sales: number }>, output_files: Record<string, string> }} IndependentPharmacyActivityResponse */

export const INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT =
  "cli/threads/reporte_actividad_independientes";

const REQUEST_CHECKER_STATUS_ENDPOINT = "request_checker/status";
const REPORT_DATA_JSON_PREFIX = "REPORT_DATA_JSON=";

/**
 * @param {number} fromPeriod
 * @param {number} toPeriod
 * @returns {Promise<{ id: string | number }>}
 */
export async function startIndependentPharmacyActivityThread(
  fromPeriod,
  toPeriod,
) {
  const formData = new FormData();
  formData.append("from_period", String(fromPeriod));
  formData.append("to_period", String(toPeriod));
  const response = await dbPostWithFormData(
    INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT,
    formData,
  );
  const requestId = response?.id || response?.import_id;

  if (!requestId) {
    throw new Error("No se pudo iniciar el reporte: respuesta inválida.");
  }

  return { id: requestId };
}

/**
 * @param {string | number} id
 * @returns {Promise<any>}
 */
export function getIndependentPharmacyActivityThreadStatus(id) {
  return dbGet(
    `${REQUEST_CHECKER_STATUS_ENDPOINT}?id=${encodeURIComponent(id)}`,
  );
}

/**
 * @param {string[]} stdout
 * @returns {Array<{ period: number, enrolled_pharmacies: number, active_pharmacies: number, new_pharmacies_with_sales: number }>}
 */
export function parseReportDataFromStdout(stdout) {
  const reportDataLine = (Array.isArray(stdout) ? stdout : []).find((line) =>
    String(line).startsWith(REPORT_DATA_JSON_PREFIX),
  );

  if (!reportDataLine) {
    throw new Error(
      "El reporte finalizó, pero no devolvió los datos de resumen para la tabla.",
    );
  }

  try {
    const reportData = JSON.parse(
      reportDataLine.slice(REPORT_DATA_JSON_PREFIX.length),
    );

    if (!Array.isArray(reportData)) {
      throw new Error();
    }

    return reportData;
  } catch {
    throw new Error(
      "El reporte finalizó, pero los datos de resumen recibidos no son válidos.",
    );
  }
}

/**
 * @param {any} response
 * @returns {IndependentPharmacyActivityResponse}
 */
export function mapCompletedIndependentPharmacyActivityThread(response) {
  return {
    data: parseReportDataFromStdout(response?.data?.command_stdout),
    output_files: response?.data?.output_files || {},
  };
}
